import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppSettings } from 'app/modules/shared/app.settings';
import { Language } from 'app/modules/shared/models/language';
import { CommonBindingDataService } from 'app/modules/shared/services/common-binding-data.service';
import { InputNumberModule } from 'primeng/inputnumber';

@Component({
  selector: 'app-input-price',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, InputNumberModule],
  templateUrl: './input-price.component.html',
  styleUrl: './input-price.component.scss'
})
export class InputPriceComponent implements OnInit {
  @Input() field: any;
  formName: FormGroup;
  @Input() attributeLabels: [];
  @Input() moduleName: string;
  placeholder: any = null;
  unit: string = '';
  language: Language;
  languageCode: string;

  constructor(private formGroupDirective: FormGroupDirective,
    public cs: CommonBindingDataService) {
    this.formName = this.formGroupDirective.control;
    this.language = JSON.parse(localStorage.getItem(AppSettings.LANGUAGE));
    this.languageCode = this.language[0].langCode;
  }

  ngOnInit() {
    this.placeholder = this.cs.getLabel('settings.lbl_enter_value');
  }
}
